import VueRouter from 'vue-router';
import AuthService from '../services/AuthService';
import {routes} from './routes';
import NProgress from 'nprogress';

export const router = new VueRouter({
    mode: 'hash',
    routes,
});

export function beforeEach(to, from, next) {
    NProgress.start();
    if (to.meta && to.meta.title) {
        window.metaTitle(to.meta.title);
    } else {
        window.metaTitle('');
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        AuthService.getUser().then(() => {
            let accessGranted = false;
            if (to.matched.some(record => record.meta.requiresOffice) && AuthService.user.office_access) {
                accessGranted = true;
            }
            if (to.matched.some(record => record.meta.requiresEngineer) && AuthService.user.engineer_access) {
                accessGranted = true;
            }
            if (to.matched.some(record => record.meta.requiresAdmin) && AuthService.user.admin_access) {
                accessGranted = true;
            }
            if (to.matched.some(record => record.meta.requiresAdmin) && !AuthService.user.admin_access) {
                accessGranted = false;
            }
            if (accessGranted) {
                next();
            } else {
                next({
                    path: '/',
                    query: {
                        access: 'denied',
                    },
                });
            }
        }, () => {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        });
    }
    else if (to.matched.some(record => record.meta.requiresGuest)) {
        AuthService.getUser().then(() => {
            next({
                path: '/',
            });
        }, () => {
            next();
        });
    } else {
        next() // make sure to always call next()!
    }
}

export function afterEach() {
    NProgress.done();
}


// WEBPACK FOOTER //
// ./resources/assets/js/routing/router.js